export enum OrderDetailFilterIds {
  Category = 'category',
  Status = 'status',
  Delivery = 'delivery',
}

export interface OrderDetailFilter {
  fieldId: OrderDetailFilterIds;
  displayValue: string;
  values: string[];
}

export enum OrderItemDeliveryStatus {
  DELIVERY_UNCONFIRMED = 'delivery_unconfirmed',
  INBOUND = 'inbound',
  DELIVERED = 'delivered',
}
